module.exports = __webpack_public_path__ + "static/media/mail_input.18a98bfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail_input.svg
// module id = 29
// module chunks = 0